// 商品ページ追従ボタン
document.addEventListener('scroll', function () {
  const targetElem = document.querySelector('.mxpr-favorites-button');

  if (!targetElem) {
    return;
  }
  const targetRect = targetElem.getBoundingClientRect();

  const formScrollBtn = document.querySelector('.js-form-scroll');
  const fixedElem = document.querySelector('.js-fixed-btns');

  const scrollBtn = document.querySelector('.js-scroll-top');
  const fixedElemHeight = fixedElem.clientHeight;
  const scrollBtnSpacer = 10;
  const targetRectBottom = targetRect.bottom;

  // formScrollBtn.addEventListener( 'click' , scrollForm );
  // function scrollForm(){
  //   const targetRectTop = targetRect.top;
  //   window.scroll({top: targetRectTop, behavior: 'smooth'});
  //     fixedElem.classList.remove("is-active");
  //     scrollBtn.style.bottom = scrollBtnSpacer + "px";
  // };

  formScrollBtn?.addEventListener('click', function () {
    fixedElem.classList.remove('is-active');
  });

  if (0 > targetRectBottom) {
    fixedElem.classList.add('is-active');
    scrollBtn.style.bottom = fixedElemHeight + scrollBtnSpacer + 'px';
  } else if (0 < targetRectBottom) {
    fixedElem.classList.remove('is-active');
    scrollBtn.style.bottom = scrollBtnSpacer + 'px';
  }
});
/***********
// カート内情報取得
function getCartItemCount(){
  return fetch('/cart.js')
  .then(response => {
      return response.json();
  })
  .then(data => {
    return data.item_count;
  })
}

// カート追加処理
function addToCart(variantId, quantity){
  let item_count = 0;
  let formData = {
   'items': [{
    'id': variantId,
    'quantity': quantity
    }]
  };
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  // .then(function(data) {
  // 	console.log(JSON.stringify(data));
  // })
  .catch((error) => {
    console.error('Error:', error);
  });
};

// カートの商品数表示
function addCartItemCount(itemCount){
  let cartCountElem = document.querySelector(".js-cart-item-counts");
  cartCountElem.textContent = itemCount;
  console.log(itemCount);

  let cartBubbleResult = document.getElementsByClassName("cart-count-bubble").length > 0;
  console.log(cartBubbleResult);
  if(cartBubbleResult){
    let cartBubbleElem = document.getElementsByClassName("cart-count-bubble")[0];
    let cartBubbleCountElem = cartBubbleElem.querySelectorAll("span");
    cartBubbleCountElem.forEach((elem) => {
      let elemResult = elem.classList.contains("visually-hidden")
      if( elemResult){
        elem.textContent = itemCount + " items";
      } else {
        elem.textContent = itemCount;
      }
    });
  } else {
    let cartBubbleParentElem = document.createElement('div');
    cartBubbleParentElem.classList.add("cart-count-bubble")
    let cartBubbleChildElem = document.createElement('span');
    cartBubbleChildElem.areaHidden = "true";
    cartBubbleChildElem.textContent = itemCount;
    cartBubbleParentElem.appendChild(cartBubbleChildElem);
    let cartBubbleNextChildElem = document.createElement('span');
    cartBubbleNextChildElem.classList.add("visually-hidden");
    cartBubbleNextChildElem.textContent = itemCount + " items";
    cartBubbleParentElem.appendChild(cartBubbleNextChildElem);

    const headerCart = document.getElementById("cart-icon-bubble");
    headerCart.appendChild(cartBubbleParentElem)
  }
}

// cart modal
document.addEventListener('DOMContentLoaded', function(){
  const openFormModalBtn = document.querySelector('[data-date="pick"]');
  const addCartBtn = document.querySelector('[data-date="picked"]');
  const formModalAddToCartBtn = document.querySelector('.js-add-to-cart-btn');

  const modalOptionsElem = document.querySelector('.js-product-modal.modal-options');
  const modalCartElem =  document.querySelector('.js-product-modal.modal-cart');
  const modalBg = document.querySelector('.js-modal-bg');
  const optionsModalCloseBtn = document.querySelector('.js-product-modal.modal-options .js-modal-close');
  const cartModalCloseBtn = document.querySelector('.js-product-modal.modal-cart .js-modal-close');
  const htmlElem = document.querySelector('html');

  function optionsModalOpen(){
    modalOptionsElem.classList.add("is-active");
    modalBg.classList.add("is-active");
    htmlElem.classList.add("is-open");
  };

  function cartModalOpen(){
    modalCartElem.classList.add("is-active");
    modalBg.classList.add("is-active");
    htmlElem.classList.add("is-open");
  };

  function optionsModalClose(){
    modalOptionsElem.classList.remove("is-active");
    modalBg.classList.remove("is-active");
    htmlElem.classList.remove("is-open");
  };

  function optionsModalElemClose(){
    modalOptionsElem.classList.remove("is-active");
  };

  function cartModalElemOpen(){
    modalCartElem.classList.add("is-active");
    htmlElem.classList.add("is-open");
  };

  function allModalClose(){
    const optionsModalResult = modalOptionsElem.classList.contains("is-active");
    const cartModalResult = modalCartElem.classList.contains("is-active");
    if(optionsModalResult){
      modalOptionsElem.classList.remove("is-active");
    }
    if(cartModalResult){
      modalCartElem.classList.remove("is-active");
    }
    modalBg.classList.remove("is-active");
    htmlElem.classList.remove("is-open");
  };

  //  お届け希望日指定モーダル オープン
  openFormModalBtn.addEventListener( 'click' ,function(){
    optionsModalOpen();
  });

  //  お届け希望日指定モーダル クローズボタン
  optionsModalCloseBtn.addEventListener( 'click' ,function(){
    allModalClose();
  });

  //  カート追加後モーダル クローズボタン
  cartModalCloseBtn.addEventListener( 'click' ,function(){
    allModalClose();
  });

  // モーダルのBGクリック
  modalBg.addEventListener( 'click' ,function(){
    allModalClose();
  });

  // 最短のお届け希望ボタンクリック
  addCartBtn.addEventListener( 'click' ,function(){
    const variantId = document.add_to_cart.variant_id.value;
    const quantity = document.add_to_cart.quantity.value;
    (async()=>{
      const res = await addToCart(variantId, quantity);
      const cartItemCount = await getCartItemCount();
      console.log("cart quantity: " + cartItemCount);
      addCartItemCount(cartItemCount);
      cartModalOpen();
    })();
  });

  // お届け希望日指定モーダル カート追加
  formModalAddToCartBtn.addEventListener( 'click' ,function(){
    const variantId = document.add_to_cart.variant_id.value;
    const quantity = document.add_to_cart.quantity.value;
    (async()=>{
      const res = await addToCart(variantId, quantity);
      const cartItemCount = await getCartItemCount();
      console.log("cart quantity: " + cartItemCount);
      addCartItemCount(cartItemCount);
      optionsModalElemClose();
      cartModalElemOpen();
    })();
  });
});
*********/

// スライダーコントローラー
// document.addEventListener('DOMContentLoaded', function(){
//   const arrowPrev = document.querySelector(".slider__prev");
//   const arrowNext = document.querySelector(".slider__next");
//   const targetElem = document.querySelector(".product__media-list");
//   const target = targetElem.getElementsByClassName("slider__slide");
//   arrowPrev.classList.add("is-disable")
//
//   arrowNext.addEventListener( 'click' ,function(){
//     let activeElem = ""
//     for(let [index, elem] of Object.entries(target)){
//       if(elem.classList.contains("is-active")){
//         elem.classList.remove("is-active");
//         activeElem = elem;
//         const mediaId = activeElem.dataset.mediaId;
//         console.log(mediaId);
//         const sliderIndex = Number(index) + 2
//         if(sliderIndex === target.length){
//           arrowNext.classList.add("is-disable");
//         }
//       }
//     };
//
//     console.log(target.length);
//     const nextElem = activeElem.nextElementSibling;
//     activeElem.classList.remove("is-active");
//     nextElem.classList.add("is-active");
//
//     if(arrowPrev.classList.contains("is-disable")){
//       arrowPrev.classList.remove("is-disable")
//     }
//   });
//
//   arrowPrev.addEventListener( 'click' ,function(){
//     let activeElem = ""
//     for(let [index, elem] of Object.entries(target)){
//       if(elem.classList.contains("is-active")){
//         elem.classList.remove("is-active");
//         activeElem = elem;
//         const sliderIndex = Number(index)
//         if(sliderIndex === 1){
//           arrowPrev.classList.add("is-disable");
//         }
//       }
//     };
//
//     console.log(target.length);
//     const prevElem = activeElem.previousElementSibling;
//     activeElem.classList.remove("is-active");
//     prevElem.classList.add("is-active");
//
//     if(arrowNext.classList.contains("is-disable")){
//       arrowNext.classList.remove("is-disable")
//     }
//   });
// });

// マウスドラッグスクロール
function mousedragscrollable(element) {
  let target;
  const elms = document.querySelectorAll(element);
  for (let i = 0; i < elms.length; i++) {
    elms[i].addEventListener('mousedown', function (evt) {
      evt.preventDefault();
      target = elms[i];
      target.dataset.down = 'true';
      target.dataset.move = 'false';
      target.dataset.x = evt.clientX;
      target.dataset.y = evt.clientY;
      target.dataset.scrollleft = target.scrollLeft;
      target.dataset.scrolltop = target.scrollTop;
      evt.stopPropagation();
    });
    elms[i].addEventListener('click', function (evt) {
      if (elms[i].detaset != null && elms[i].detaset.move == 'true')
        evt.stopPropagation();
    });
  }
  document.addEventListener('mousemove', function (evt) {
    if (target != null && target.dataset.down == 'true') {
      evt.preventDefault();
      let move_x = parseInt(target.dataset.x) - evt.clientX;
      let move_y = parseInt(target.dataset.y) - evt.clientY;
      if (move_x !== 0 || move_y !== 0) {
        target.dataset.move = 'true';
      } else {
        return;
      }
      target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
      target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
      evt.stopPropagation();
    }
  });
  document.addEventListener('mouseup', function (evt) {
    if (target != null && target.dataset.down == 'true') {
      target.dataset.down = 'false';
      evt.stopPropagation();
    }
  });
}

window.addEventListener('DOMContentLoaded', function () {
  mousedragscrollable('.product-form__input-group');
});
